import React from "react";
import { Link } from "react-router-dom";
import { Palette, Upload, Layers, Truck, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";

const STEPS = [
  { n: "01", title: "Elige tu producto", icon: Layers, copy: "Selecciona entre playeras, tazas, termos o camisas. Cada producto tiene sus propias variantes de color y talla." },
  { n: "02", title: "Sube tu diseño", icon: Upload, copy: "Arrastra tu imagen en PNG, JPG o WEBP. Nosotros la optimizamos para impresión." },
  { n: "03", title: "Personaliza y previsualiza", icon: Palette, copy: "Verás en tiempo real cómo lucirá tu producto final gracias al mockup interactivo." },
  { n: "04", title: "Confirmamos y enviamos", icon: Truck, copy: "Producimos, empacamos y enviamos a tu puerta con seguimiento en tiempo real." },
];

export default function HowItWorksPage() {
  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12" data-testid="how-page">
      <div className="text-xs font-mono uppercase text-neutral-500">/como funciona</div>
      <h1 className="font-display text-5xl md:text-7xl tracking-tighter mt-1">
        De la idea al<br />producto en 4 pasos.
      </h1>

      <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        {STEPS.map((s) => (
          <div key={s.n} className="brutal-card p-6" data-testid={`how-step-${s.n}`}>
            <div className="flex items-center justify-between">
              <s.icon className="w-6 h-6 text-[#FF3B30]" />
              <span className="font-mono text-xs text-neutral-400">{s.n}</span>
            </div>
            <h3 className="font-display text-xl mt-6 tracking-tight">{s.title}</h3>
            <p className="text-sm text-neutral-600 mt-2">{s.copy}</p>
          </div>
        ))}
      </div>

      <div className="mt-16 brutal-card p-10 md:p-16 bg-neutral-50 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <h3 className="font-display text-3xl md:text-4xl tracking-tighter">¿Listo para crear?</h3>
          <p className="text-sm text-neutral-600 mt-2">Explora el catálogo y sube tu primer diseño.</p>
        </div>
        <Button asChild size="lg" className="brutal-btn bg-black hover:bg-[#FF3B30] text-white h-12 px-6">
          <Link to="/tienda">Ir a la tienda <ArrowRight className="w-4 h-4 ml-2" /></Link>
        </Button>
      </div>
    </div>
  );
}
